import { useState } from "react";
import { Play, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Container, MaskText, Reveal, Overline, ease } from "./primitives";

export const VideoBlock = () => {
  const [open, setOpen] = useState(false);
  return (
    <section className="relative bg-[#060B19] py-20 text-white lg:py-32" data-testid="video-section">
      <Container className="grid gap-12 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-4">
          <Overline dark>Visão & método</Overline>
          <MaskText className="font-display mt-6 text-3xl font-bold leading-[1.02] tracking-[-0.03em] sm:text-4xl lg:text-5xl"
            lines={["Conheça a visão", "e o método de", <span className="text-[#CCFF00]">Maicon Roberto.</span>]} />
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-sm text-base leading-relaxed text-slate-300">
              Em poucos minutos, entenda como estratégia, marketing e vendas funcionam juntos para gerar crescimento real.
            </p>
          </Reveal>
        </div>
        <Reveal className="lg:col-span-8" y={60}>
          <button onClick={() => setOpen(true)} data-testid="video-trigger-button"
            className="group relative block aspect-video w-full overflow-hidden rounded-[24px] text-left">
            <img src="/img/video.jpg" alt="Apresentação do método" className="absolute inset-0 h-full w-full object-cover grayscale transition-transform duration-1000 ease-out group-hover:scale-105" />
            <div className="absolute inset-0 bg-[#1238CE] mix-blend-multiply opacity-70" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#060B19]/90 to-transparent" />
            <span className="absolute left-1/2 top-1/2 grid h-24 w-24 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-[#CCFF00] text-[#060B19] transition-transform duration-500 group-hover:scale-110 sm:h-28 sm:w-28">
              <span className="absolute inset-0 animate-ping rounded-full bg-[#CCFF00]/40" />
              <Play className="relative ml-1 h-8 w-8 fill-current" />
            </span>
            <div className="absolute bottom-5 left-5 right-5 flex flex-wrap items-center justify-between gap-3 sm:bottom-7 sm:left-7 sm:right-7">
              <span className="font-display text-lg font-semibold sm:text-2xl">Estratégia, marketing e vendas na prática</span>
              <span className="font-mono-x rounded-full bg-white/10 px-3 py-1 text-xs backdrop-blur">[vídeo placeholder]</span>
            </div>
          </button>
        </Reveal>
      </Container>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[80] grid place-items-center bg-[#060B19]/90 p-5 backdrop-blur-xl" onClick={() => setOpen(false)} data-testid="video-modal">
            <motion.div initial={{ scale: 0.92, y: 30 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.95 }} transition={{ duration: 0.6, ease }}
              className="relative grid aspect-video w-full max-w-4xl place-items-center rounded-2xl border border-white/10 bg-[#0C142A]" onClick={(e) => e.stopPropagation()}>
              <p className="px-6 text-center text-slate-300">[placeholder] Envie o link do vídeo (YouTube ou Vimeo) para exibi-lo aqui.</p>
              <button onClick={() => setOpen(false)} className="absolute -top-14 right-0 grid h-11 w-11 place-items-center rounded-full bg-white text-[#060B19]" data-testid="video-modal-close-button" aria-label="Fechar">
                <X size={18} />
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
